import axios from 'axios'
import { extractError } from '../utils/errorHandler'

export const getCurrent = async (includeDeleted = false) => {
  try {
    const { data: notifications } = await axios.get('notification', {
      params: { includeDeleted },
    })
    return notifications
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const create = async (notification) => {
  try {
    const { data: createdNotifications } = await axios.post('notification', notification)
    return createdNotifications
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const markAsRead = async (id) => {
  try {
    const { data: notification } = await axios.post(`notification/${id}/markAsRead`)
    return notification
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const markAllAsRead = async (ids) => {
  try {
    const { data: notifications } = await axios.post('notification/markAllAsRead', { ids })
    return notifications
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const remove = async (id) => {
  try {
    await axios.delete(`notification/${id}`)
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const removeMany = async (ids) => {
  try {
    await axios.post('notification/deleteAll', { ids })
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}
